import { CHANGE_PASSWORD_URL, CLIENT_ID, GRIFFIN_URL, LDB_URL, LOGOUT_URL, REDIRECT_URI } from "../common/constants"

export const redirectToAuthenticate = async () => {
    const response = await fetch(
      `${GRIFFIN_URL}accounts/pkce/init/?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}`
    );
    const data = await response.json();
    window.location.href = data.authorize_url;
}

export const getLogoutURL = () => {
    const params = { next_page: LDB_URL }
    const encodedParams = Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join('&')
    return `${LOGOUT_URL}?${encodedParams}`
}

export const getChangePasswordURL = () => {
    const currentPage = window.location.href

    return `${CHANGE_PASSWORD_URL}/?next_page=${currentPage}`
}
  